import { useCallback } from 'react';

// @ts-ignore
import redirects from 'generated/redirects';

const useRedirects = () => {
  const resolveRedirects = useCallback((path: string): string | undefined => {
    const redirectsPath: string = redirects[path as any] || '';
    if (redirectsPath) {
      return redirectsPath;
    }
  }, []);

  return resolveRedirects;
};

export default useRedirects;
